/** @file Ordered migration steps (n → n+1) for the editor document; empty at schema version 1. */
export const MIGRATION_STEPS: readonly { from: number; description: string }[] = [];
